export default "__VITE_ASSET__Dr_qDao0__"